import React from 'react'
import { PageHeader, SurfaceCard } from '../../Components/Ui'
import NotiForm from './NotiForm'

const Noti = () => {
    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Nuevo Noti Super"
            subtitle="Completa el formulario para publicar una nueva notificación."
        />
        <SurfaceCard>
            <NotiForm />
        </SurfaceCard>
    </>
}

export default Noti
